/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomListForm } from '../models/CustomListForm';
import type { CustomListProjection } from '../models/CustomListProjection';
import type { PageCustomListProjection } from '../models/PageCustomListProjection';
import type { PageFanResponseProjection } from '../models/PageFanResponseProjection';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardCustomListRestEndpointService {
    /**
     * @returns CustomListProjection OK
     * @throws ApiError
     */
    public static dashboardGetCustomList({
        creatorId,
        listId,
    }: {
        creatorId: number,
        listId: number,
    }): CancelablePromise<CustomListProjection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/list-feature/custom-list/creator/{creatorId}/list/{listId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static dashboardUpdateCustomList({
        creatorId,
        listId,
        requestBody,
    }: {
        creatorId: number,
        listId: number,
        requestBody: CustomListForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/list-feature/custom-list/creator/{creatorId}/list/{listId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static dashboardDeleteCustomList({
        creatorId,
        listId,
    }: {
        creatorId: number,
        listId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/list-feature/custom-list/creator/{creatorId}/list/{listId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
        });
    }
    /**
     * @returns PageCustomListProjection OK
     * @throws ApiError
     */
    public static dashboardGetCustomLists({
        creatorId,
        name,
        page,
        size = 20,
    }: {
        creatorId: number,
        name?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<PageCustomListProjection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/list-feature/custom-list/creator/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'name': name,
                'page': page,
                'size': size,
            },
        });
    }
    /**
     * @returns CustomListProjection OK
     * @throws ApiError
     */
    public static dashboardCreateCustomList({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: CustomListForm,
    }): CancelablePromise<CustomListProjection> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/list-feature/custom-list/creator/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PageFanResponseProjection OK
     * @throws ApiError
     */
    public static dashboardGetCustomListFans({
        creatorId,
        listId,
        fanName,
        page,
        size = 20,
    }: {
        creatorId: number,
        listId: number,
        fanName?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<PageFanResponseProjection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/list-feature/custom-list/creator/{creatorId}/list/{listId}/fans',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
            query: {
                'fanName': fanName,
                'page': page,
                'size': size,
            },
        });
    }
}
